import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  createLoadByIdReducer, createLoadListReducerWithBegin, createOperationStateReducer, initialStateCRUD,
} from '../../utils/getCrudConfig';
import { MODULE_NAME } from './constants';
import {
  CREATE, DELETE_BY_ID, LOAD_BY_ID, LOAD_LIST, UPDATE,
} from '../../configs/actionNames';
import { USER_MODULE } from '../../configs/moduleNames';

const initialState = {
  ...initialStateCRUD,
  loadingStats: false,
  userListMeta: {},
  userList: [],
  loadingUserList: false,
  currentUser: {},
  loadingCurrentUser: false,
  loadingCreateUser: false,
  loadingEditUserById: false,
  loadingDeleteUser: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(MODULE_NAME + LOAD_LIST, 'userList', 'loadingUserList'),
  ...createLoadByIdReducer(MODULE_NAME + LOAD_BY_ID, 'currentUser', 'loadingCurrentUser'),
  ...createOperationStateReducer(MODULE_NAME + CREATE, 'loadingCreateUser'),
  ...createOperationStateReducer(MODULE_NAME + DELETE_BY_ID, 'loadingDeleteUser'),
  ...createOperationStateReducer(MODULE_NAME + UPDATE, 'loadingEditUserById'),
}, initialState);

export default reducer;

export const getUserData = createSelector(
  [state => state[USER_MODULE]],
  state => {
    const {
      userList,
      userListMeta,
      loadingUserList,
      currentUser,
      loadingCurrentUser,
      loadingCreateUser,
      loadingEditUserById,
      loadingDeleteUser,
    } = state;
    return {
      userList,
      userListMeta,
      loadingUserList,
      currentUser,
      loadingCurrentUser,
      loadingCreateUser,
      loadingEditUserById,
      loadingDeleteUser,
    };
  },
);
